import { Injectable, OnInit } from '@angular/core';
import { User } from '../models/user.model';
import { Observable, BehaviorSubject } from 'rxjs';
import { IInfoUserResponse } from '../models/response';

@Injectable()

export class UserService implements OnInit {
    nomeAnonimo : string
    cognomeAnonimo : string
    customerid : string
    codTesseraFind : string
    key: string
    static user: BehaviorSubject<User> = new BehaviorSubject(new User());
    static prefix: BehaviorSubject<string> = new BehaviorSubject("");
    constructor() {

    }

    ngOnInit() { }

    /*   user */
    setUser(NewUser: User) {
       // console.log("Dentro setUser "+ NewUser);
        UserService.user.next(NewUser);
    }
    getUser(): Observable<User> {
        return UserService.user.asObservable();
    }

    /*   prefix number */
    setPrefixNumber(prefix: string) {
        UserService.prefix.next(prefix);
    }
    getPrefixNumber() {
        return UserService.prefix.asObservable();
    }

    resetUser(userInfo: IInfoUserResponse) {
        var {
            nome, cognome, dataDiNascita, luogo, sesso, cf, nazionalita, anonimo, codTessera, rowidCustomer,
            statoResidenza, provincia, cap, comune, via, numero, latitude, longitude, istatCOMUNALE, istatREGIONALE, sezioneCensimento,
            telefonoCellulare, telefonoFisso, username, email,
            pdvBennetDrive, pdvPreferito, pdvRitiroPremi, privacyGDPR, privacyMktg, privacyProf, metodoDiContattoPreferito,
            intrssGiardinaggio, intrssFaiDaTe, intrssAuto, intrssGourmetEVini, intrssAnimali, intrssBambino, intrssTecnologia, intrssBio, intrssSport,
            privacyEMAIL, privacyISMSG, privacyLETTERA, privacySMS, privacyTEL,mustResetPwd,cod2FAuth,
        } = userInfo;
       // console.log("Dentro resetUser : "+ userInfo);
        var user = new User();
        let REG = new RegExp(/^([1-9][0-9]{3}(-)[0-9]{2}(-)[0-9]{2})/);

        // normalize Date of birth
        if (dataDiNascita && REG.test(dataDiNascita)) {
            var ddn;
            ddn = dataDiNascita.split(' ');
            ddn = ddn[0];
            ddn = ddn.split('-');
            ddn = ddn[2] + "/" + ddn[1] + "/" + ddn[0];
            user.info.dataDiNascita = ddn;
        } else {
            user.info.dataDiNascita = "";

        }
        // Normalize Phone number
        if (telefonoCellulare) {
            var number: string = telefonoCellulare + "";
            if (number[0] == '+') {
                var prefix = number.slice(0, 3);
                if (prefix == "+39" || prefix == "+41") {
                    this.setPrefixNumber(prefix)
                    user.contacts.cellulare = number.slice(3, number.length)
                } else {
                    this.setPrefixNumber("+")
                    user.contacts.cellulare = number.slice(1, number.length)
                }
            } else {
                this.setPrefixNumber("+")
                user.contacts.cellulare = telefonoCellulare
            }
        }
        if(anonimo == 'Y'){
          //  console.log("Nome all'interno di service "+this.nomeAnonimo)
            user.info.nome = this.nomeAnonimo;
           // console.log("Cognome all'interno di service "+this.cognomeAnonimo)
            user.info.cognome = this.cognomeAnonimo;
        }else{
            user.info.nome = nome;
            user.info.cognome = cognome; 
        }
        if(this.codTesseraFind ){
            user.info.codTessera=this.codTesseraFind;
        }
        else         user.info.codTessera = codTessera;


        user.info.luogoDiNascita = luogo;
        user.info.sesso = sesso;
        user.info.cf = cf;
        user.info.nazionalita = nazionalita;
        user.info.anonimo = anonimo;
        user.info.mustResetPwd=mustResetPwd;
        user.info.cod2FAuth=cod2FAuth;
        user.contacts.email = email;
        user.account.email = username;
        user.address.stato = statoResidenza;
        user.address.provincia = provincia;
        user.address.cap = cap;
        user.address.civico = numero;
        user.address.localita = comune;
        user.address.via = via;
        user.address.longitudine = latitude;
        user.address.latitudine = latitude;
        user.address.istatComunale = istatCOMUNALE;
        user.address.istatRegionale = istatREGIONALE;
        user.address.sezioneCensimento = sezioneCensimento;
        user.pdv.preferenze.drive = pdvBennetDrive;
        user.pdv.preferenze.preferito = pdvPreferito;
        user.pdv.preferenze.ritiroPremi = pdvRitiroPremi;
        user.pdv.privacy[0].value = privacyGDPR ? privacyGDPR : 'N';
        user.pdv.privacy[1].value = privacyMktg ? privacyMktg : 'N';
        user.pdv.privacy[1].favoriteMethod = metodoDiContattoPreferito;
        user.pdv.privacy[2].value = privacyProf ? privacyProf : 'N';
        user.pdv.privacy[3].value = privacyEMAIL ? privacyEMAIL : 'N';
        user.pdv.privacy[4].value = privacySMS ? privacySMS : 'N';
        user.pdv.privacy[5].value = privacyTEL ? privacyTEL : 'N';
        user.pdv.privacy[6].value = privacyLETTERA ? privacyLETTERA : 'N';
        user.pdv.privacy[7].value = privacyISMSG ? privacyISMSG : 'N';
        user.pdv.interessi[0].value = intrssAuto ? intrssAuto : 'N';
        user.pdv.interessi[1].value = intrssBambino ? intrssBambino : 'N';
        user.pdv.interessi[2].value = intrssFaiDaTe ? intrssFaiDaTe : 'N';
        user.pdv.interessi[3].value = intrssGiardinaggio ? intrssGiardinaggio : 'N';
        user.pdv.interessi[4].value = intrssAnimali ? intrssAnimali : 'N';
        user.pdv.interessi[5].value = intrssBio ? intrssBio : 'N';
        user.pdv.interessi[6].value = intrssTecnologia ? intrssTecnologia : 'N';
        user.pdv.interessi[7].value = intrssGourmetEVini ? intrssGourmetEVini : 'N';
        user.pdv.interessi[8].value = intrssSport ? intrssSport : 'N';
        this.setUser(user);
    }
}


// WEBPACK FOOTER //
// ./src/app/theme/services/user.service.ts